var render = function render(){var _vm=this,_c=_vm._self._c;return _c('database-layout',[_c('div',[_vm._v("Database Dashboard")])])
}
var staticRenderFns = []

export { render, staticRenderFns }